module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"url":"Url","click to edit":"Klicken Sie hier zum Editieren."}}')
  delete Component.options._Ctor
}
